import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'card-wrapper',
  templateUrl: './card-wrapper.component.html',
  styleUrls: ['./card-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardWrapperComponent {
  /**
   * Свойство для отображения отступов вокруг карточки
   *
   * @type {boolean}
   * @memberof CardWrapperComponent
   */
  @Input() noPadding: boolean;

  /**
   * Add overflow:hidden to parent div
   *
   * @type {boolean}
   * @memberof CardWrapperComponent
   */
  @Input() overflow: boolean;

  /**
   * Create class structure with given class
   * `.card-wrapper.inner-class > .card-wrapper__content.inner-class-content`
   *
   * @type {string}
   * @memberof CardWrapperComponent
   */
  @Input() innerClass: string;
}
